var render = function render(){var _vm=this,_c=_vm._self._c;return _c('share-entity-dialog',{ref:"base",attrs:{"collection":"routines","title":_vm.$t('routines.share_routine'),"shared-toast":_vm.$t('routines.shared')}})
}
var staticRenderFns = []

export { render, staticRenderFns }